
interface SetIsCalendarAction {
  type: "SET_IS_CALENDAR";
  swtch: boolean;
}

export type KnownAction =
  | SetIsCalendarAction;

export const setIsCalendar = (swtch: boolean): SetIsCalendarAction =>
  ({ type: "SET_IS_CALENDAR", swtch });
